import { html } from "lit-html"
import { virtual } from "haunted"

import OutOfRangeTag from "../generic/out-of-range-tag"

const UserRow = virtual(
  ({
    name,
    roles,
    url,
    onboarding_eligible,
    office_approved,
    has_local_program,
    address,
    in_range,
  }) => html`
    <div class="user filter-result-row cursor-default group">
      <div class="w-full p-5">
        <a href=${url}>${name}</a>
        ${onboarding_eligible === true
          ? html`<p class="text-sm">
              Onboarding status:
              ${office_approved
                ? html`<span class="tooltip-icon inline-block">
                    <span class="font-bold text-green-active">
                      Complete via Office Approved
                    </span>
                    <span
                      class="tooltip-icon-tooltiptext w-max max-w-[260px] whitespace-normal text-center text-tiny"
                    >
                      Eligibility manually granted by staff; onboarding steps
                      bypassed.
                    </span>
                  </span>`
                : html`<span class="font-bold text-green-active">
                    Complete
                  </span>`}
            </p>`
          : onboarding_eligible === false
          ? html`<p class="text-sm">
              Onboarding status:
              <span class="font-bold text-orange-800">
                Incomplete${has_local_program === false
                  ? " (no local program)"
                  : ""}
              </span>
            </p>`
          : ""}
        ${Object.entries(roles).map(
          ([role, programs]) => html`
            <p class="capitalize text-sm">
              ${role}${programs.length !== 0
                ? ` - ${programs.sort().join(", ")}`
                : ""}
            </p>
          `
        )}
        ${address
          ? html`<p class="text-sm">${address}${OutOfRangeTag(in_range)}</p>`
          : ""}
      </div>
      <hr class="filter-result-row-divider" />
    </div>
  `
)

export default UserRow
